module.exports = "<categories-input-filter sh-ctrl=\"$ctrl.shCtrl\" ng-if=\"$ctrl.ngAuthSettings.site.config.data.categories.menuType === 1\"></categories-input-filter>\r\n\r\n<categories-slider-filter sh-ctrl=\"$ctrl.shCtrl\" ng-if=\"$ctrl.ngAuthSettings.site.config.data.categories.menuType === 2\" is-procedure=\"$ctrl.isProcedure\" company=\"$ctrl.company\" sisters=\"$ctrl.sisters\"></categories-slider-filter>\r\n\r\n<categories-sliding-filter sh-ctrl=\"$ctrl.shCtrl\" ng-if=\"$ctrl.ngAuthSettings.site.config.data.categories.menuType === 3\"></categories-sliding-filter>";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/catalog/categories-filter/templates/categories-filter-base.view.html
 ** module id = 549
 ** module chunks = 0
 **/